import type { ContentType } from "@/types/ab-tests";
import { getBulletIndex } from "@/utils/ab-test-utils";

interface ConfigurationMetaProps {
  sourceLabel: string;
  testedFields: ContentType[];
  targetPhrase: string;
  sourceDetail?: string | null;
  hypothesis: string;
}

export function ConfigurationMeta({
  sourceLabel,
  testedFields,
  targetPhrase,
  sourceDetail,
  hypothesis,
}: ConfigurationMetaProps) {
  return (
    <>
      <div className="grid grid-cols-3 gap-4 px-1">
        <div className="space-y-1">
          <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Source</p>
          <p className="text-sm text-foreground">{sourceLabel}</p>
        </div>
        <div className="space-y-1">
          <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Scope</p>
          <p className="text-sm text-foreground">
            {testedFields.map((f) => {
              if (f === "title") return "Title";
              const idx = getBulletIndex(f);
              return idx !== null ? `Bullet ${idx + 1}` : f;
            }).join(", ")}
          </p>
        </div>
        <div className="space-y-1">
          <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Target Keyword</p>
          <p className="text-sm text-foreground">{targetPhrase}</p>
        </div>
      </div>

      {sourceDetail && (() => {
        let parsedGaps: string[] | null = null;
        try {
          const result = JSON.parse(sourceDetail);
          if (Array.isArray(result) && result.every(item => typeof item === "string")) {
            parsedGaps = result;
          }
        } catch { /* plain string — render as-is */ }
        return (
          <div className="space-y-1.5 px-1">
            <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Source detail</p>
            {parsedGaps ? (
              <ul className="space-y-1 list-disc list-inside">
                {parsedGaps.map(item => (
                  <li key={item} className="text-sm leading-relaxed text-foreground">{item}</li>
                ))}
              </ul>
            ) : (
              <p className="text-sm leading-relaxed text-foreground">{sourceDetail}</p>
            )}
          </div>
        );
      })()}

      <div className="space-y-1.5 px-1">
        <p className="text-[10px] uppercase tracking-wider text-muted-foreground font-medium">Hypothesis</p>
        <p className="text-sm leading-relaxed text-foreground">{hypothesis}</p>
      </div>
    </>
  );
}
